/**
 * Remove spaces and converts all the alphabetic characters in the string to lowercase.
 *
 * L2-S13: moved verbatim from `src/app/shared/functions/lowerNoSpaces.ts` (now a shim) so
 * `TimetrackingService` could move to `@miq/platform`. Seven other host callers keep the old
 * `@shared/functions` path via the shim, like its siblings `not-null` / `first-element`.
 *
 * @param x
 * @returns string
 * @example
 *  PORTFOLIO SALE -> portfoliosale
 */
export const lowerNoSpaces = (x: string) => x.toLowerCase().replace(/\s/g, '');
